export default __webpack_public_path__ + "static/media/nf-555.fe8643a4.webp";